module.exports = __webpack_public_path__ + "src/img/checker.fe949c79.svg";